import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appBlackoutCameras',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: false,
  isMultiSelectable: true,
  sessionParams: [],
  // createPath: routes.POSTAL_GROUPS_NEW,
  // editURL: routes.POSTAL_GROUPS_EDIT,
  emptyMessage: "There hasn't been a postalcode yet.",
  fields: [
    {
      attributeName: 'cameraId',
      label: 'VideoPublish ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Video Id of the camera',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
    }, 
    {
      attributeName: 'label',
      label: 'Label',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name to identify the rule',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
    },
  ],
};
